import PrimeVue from 'primevue/config';
import Pinia from './pinia';
import i18n from './i18n';
import router from './router';
import { axios } from './axios';
import ConfirmationService from 'primevue/confirmationservice';

export default [i18n, Pinia, PrimeVue, router, ConfirmationService];
export { axios };
